import { companyCreationAxiosInstance } from '@bupa-monorepo/shared-frontend/admin/shared';
import { PhoneCallRequestData } from '@bupa-monorepo/shared-types/view-types';

export const sendPhoneCallRequest = async (body: PhoneCallRequestData) =>
  (await companyCreationAxiosInstance.post(`v1/phone-call-request/help`, body))
    .data;
